import React from "react";
import "./investAcc.scss";
import Accordion from "react-bootstrap/Accordion";
import {
  investDwnIcon,
  investPdfIcon,
  investUpArrow,
  videoIcon,
} from "../../images";

const InvestAcc = ({ accData, dwnIcon, firstNotActive, activeAccordion,setActiveAccordion }) => {
  return (
    <div className="invest_acc_container">
      <Accordion
        activeKey={activeAccordion}
        defaultActiveKey="0"
        onSelect={(eventKey) => setActiveAccordion(eventKey)}
        className="invest_acc"
      >
        {accData.map((item, i) => (
          <Accordion.Item
            eventKey={firstNotActive ? i : i + ""}
            id={item.url ? item.url.replace(/\s+/g, "-") : ""}
            key={i}
          >
            <Accordion.Header>
              <span>{item.mainTitle}</span>
              <img src={investUpArrow} alt="arrow" className="arrow" />
            </Accordion.Header>

            <Accordion.Body>
              {item?.data?.map((data, index) => (
                <div className="pdf_container" key={index}>
                  <div className={`pdf_text_wrapper`}>
                    <img
                      src={data.yt === true ? videoIcon : investPdfIcon}
                      alt="pdf icon"
                      className="pdf_icon"
                    />
                    <h4 className="pdf_title">{data.title}</h4>
                  </div>

                  {data.yt === true ? (
                    <a
                      href={data.link}
                      target="_"
                      className="pdf_link"
                      style={{
                        minWidth: "fit-content",
                      }}
                    >
                      Click Here
                    </a>
                  ) : dwnIcon ? (
                    <a href={data.link} download className={`pdf_link`}>
                      <img
                        src={investDwnIcon}
                        alt="download"
                        className="dwn_icon"
                      />
                    </a>
                  ) : (
                    <a href={data.link} download className="pdf_link">
                      Download
                    </a>
                  )}
                </div>
              ))}
            </Accordion.Body>
          </Accordion.Item>
        ))}
      </Accordion>
    </div>
  );
};

export default InvestAcc;
